export default __webpack_public_path__ + "static/media/shopper-approve.94b07fad.svg";